import { FormControl, IconButton, InputLabel, Menu, MenuItem, Select } from '@material-ui/core'
import { CloudDownload } from '@material-ui/icons'
import React, { useState } from 'react'

const CMDownloadDropdown = ({ options }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-controls={open ? 'menu-options' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <CloudDownload />
            </IconButton>
            <Menu
                id="menu-options"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {options.map(({ label, Icon, onClick }) => {
                    return <MenuItem onClick={() => {
                        onClick();
                        handleClose();
                    }}>
                        <div style={{ display: "flex", gap: "5px" }}>
                            <Icon />
                            <span>{label}</span>
                        </div>
                    </MenuItem>
                })}
            </Menu>
        </div>
    )
}

export default CMDownloadDropdown